import { create } from 'zustand'
import { persist } from 'zustand/middleware'

interface CenterInfo {
  id: string
  name: string
  city?: string | null
  country?: string | null
  logoUrl?: string | null
  role?: string | null
}

interface CenterState {
  activeCenterId: string | null
  activeCenterInfo: CenterInfo | null
  setActiveCenter: (center: CenterInfo) => void
  clearActiveCenter: () => void
}

export const useCenterStore = create<CenterState>()(
  persist(
    (set) => ({
      activeCenterId: null,
      activeCenterInfo: null,

      setActiveCenter: (center) =>
        set({ activeCenterId: center.id, activeCenterInfo: center }),

      clearActiveCenter: () =>
        set({ activeCenterId: null, activeCenterInfo: null }),
    }),
    { name: 'edive-active-center' },
  ),
)

/** Hook — returns the active center ID (or null). */
export function useActiveCenterId(): string | null {
  return useCenterStore((s) => s.activeCenterId)
}
